import ExamsSection from './ui/examSection';

export default ExamsSection;
